module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title d-flex align-items-center"
  }, [_c('span', {
    staticClass: "mr-2 mt-2 mb-2"
  }, [_vm._v("Move to Folder")]), _vm._v(" "), (_vm.updating) ? _c('Loader') : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.loading) ? _c('Loader') : (_vm.noFolders) ? _c('p', {
    staticClass: "fs-8 text-center text-muted"
  }, [_vm._v("\n        No Folders\n      ")]) : _vm._l((this.folders), function(f) {
    return _c('a', {
      staticClass: "panel-block d-flex align-items-center",
      on: {
        "click": function($event) {
          _vm.moveVideo(f.id)
        }
      }
    }, [_c('FolderIcon', {
      staticClass: "mr-2"
    }), _vm._v(" "), _c('span', {
      staticClass: "mr-2"
    }, [_vm._v(_vm._s(f.title))]), _vm._v(" "), (_vm.video.folder == f.id) ? _c('span', {
      staticClass: "bold"
    }, [_vm._v("(Current Folder)")]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.video.folder) ? _c('a', {
    staticClass: "panel-block d-flex align-items-center",
    on: {
      "click": function($event) {
        _vm.moveVideo(null)
      }
    }
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v("Remove from folder")])]) : _vm._e()], 2), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('p', {
    staticClass: "mb-1"
  }, [_vm._v("Or create a new folder")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createFolder($event)
      }
    }
  }, [_c('div', {
    staticClass: "field has-addons w-100p"
  }, [_c('div', {
    staticClass: "control is-medium grow-1",
    class: _vm.creating && 'is-loading'
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.folderTitle),
      expression: "folderTitle"
    }],
    staticClass: "input is-medium",
    attrs: {
      "placeholder": "New Folder name"
    },
    domProps: {
      "value": (_vm.folderTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.folderTitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "control is-medium"
  }, [_c('button', {
    staticClass: "button is-primary is-medium",
    class: _vm.creating && 'is-loading',
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                  Create\n              ")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-0c86207e"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MoveToFolderModal.vue
// module id = 977
// module chunks = 0